import isEmpty from 'lodash/isEmpty';
import { memoize } from 'lodash/function';
import { DISEASE } from 'utils/constants/disease';
// eslint-disable-next-line import/no-cycle
import { questionnaireApi } from 'modules/questionnaire/api';
import { getQuestions } from '../cancers/getQuestions';
import { conditionCheckByType } from './conditionCheckByType';

const BUNDLED_QUESTIONNAIRE_DISEASES = [
  DISEASE.MELANOMA_2,
  DISEASE.MDS,
  DISEASE.MPN,
  DISEASE.UTERINE,
  DISEASE.BRAIN,
  DISEASE.MM,
  DISEASE.LUNG,
  DISEASE.BREAST_2,
  DISEASE.NHL,
  DISEASE.CRC_2,
  DISEASE.PROSTATE,
  DISEASE.AML,
  DISEASE.HNSCC,
  DISEASE.BLADDER_2,
  DISEASE.CLL,
  DISEASE.GI_TRACT,
  DISEASE.OVARIAN,
  DISEASE.HCC,
];

export function conditionsChecker(conditionProfile, conditions, state = {}) {
  if (!conditions || conditions.length <= 0) {
    return true;
  }

  const profile = isEmpty(conditionProfile) ? {} : conditionProfile;
  const checks = conditions.map((condition) => conditionCheckByType(profile, condition, state));

  return checks.every((check) => check === true);
}

export const isBundledQuestionnaire = (disease) => BUNDLED_QUESTIONNAIRE_DISEASES.includes(disease);

/**
 * @param disease {string}
 * @param additionalParams {{ diseaseSubTypeField: string, diseaseSubTypeValue: string } | undefined}
 * @return {Promise<{id: string}[]>}
 */
export const getQuestionnaireQuestions = memoize(
  (disease, additionalParams) => {
    if (isBundledQuestionnaire(disease)) {
      return getQuestions(disease);
    }
    return questionnaireApi.getQuestionnaireStructure(disease, additionalParams);
  },
  (disease, additionalParams = {}) => (
    isBundledQuestionnaire(disease) ? disease : JSON.stringify({ disease, additionalParams })
  ),
);

export const isIndicationFromBackend = (indication) => !isBundledQuestionnaire(indication);
